import type { AssessmentActivityRegisterResponse } from '@risksmart-app/trpc/src/types';
import type { GetOversightAssessmentActivitiesQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetOversightAssessmentActivitiesDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetOversightAssessmentActivitiesRegisterArgs = Record<string, never>;

export const useGetOversightAssessmentActivitiesRegister = createQueryHook<
  UseGetOversightAssessmentActivitiesRegisterArgs,
  AssessmentActivityRegisterResponse,
  GetOversightAssessmentActivitiesQuery
>({
  trpcQueryOptions: (trpc) =>
    trpc.frontend.assessment.oversightActivityRegister.queryOptions(),
  mapTrpcDataToGraphQL: (data) => ({
    assessment_activity: data.assessment_activity,
  }),
  graphqlDocument: GetOversightAssessmentActivitiesDocument,
});
